import SupportComponent from "./SupportComponent";
import type {
  FAQ,
} from "./SupportComponent";

export const faqs: Array<FAQ> = [
  {
    question: "How do I reset my password?",
    answer:
      "Logout and go to the login page, click 'Forgot Password?', and follow the instructions.",
  },
  {
    question: "How do I delete my account?",
    answer:
      "Contact support and request account deletion. This process is irreversible.",
  },
];

const SupportContent = () => {
  return <SupportComponent faqContent={faqs} />;
};

export default SupportContent;
